import styled from 'styled-components'
import { Button } from 'core/components/Core'

export const ModalButtonLeft = styled(Button).attrs({ variant: 'text', color: 'primary' })`
  font-size: 20px;
  padding: 10px 32px;
`

export const ModalButtonRight = styled(ModalButtonLeft).attrs({ variant: 'contained' })`
  .MaasProduct-MuiDialogActions-spacing > :not(:first-child)& {
    margin-left: 16px;
  }
`
